<template>
	<div class="font-h5-regular color-gy-9">
		<Tag :content="item" style="display: inline-block" v-for="(item, index) in row.roleName" :key="index" class="mr-4"></Tag>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
import Tag from '@/components/ui/tag';
export default {
	mixins: [mixin],
    components:{
        Tag
    }
};
</script>
